import get from '../helpers/get';
import range from '../helpers/range';
import createPerSliceIdSelector from '../helpers/createPerSliceIdSelector';

export default ({
  stateSliceName,
  itemTypePlural,
  itemSetNamePlural = 'slices',
  defaultPageSize,
}) => {
  const getPageSize = (state, sliceId) => (
    get(state, [stateSliceName, itemSetNamePlural, sliceId, 'pageSize']) || defaultPageSize
  );
  const getTotalCount = (state, sliceId) => (
    get(state, [stateSliceName, itemSetNamePlural, sliceId, 'totalCount'])
  );
  const getPage = (state, sliceId) => (
    get(state, [stateSliceName, itemSetNamePlural, sliceId, 'page']) || 0
  );
  const hasMorePages = createPerSliceIdSelector(
    getTotalCount,
    getPage,
    getPageSize,
    (totalCount, page, pageSize) => (
      (totalCount === undefined)
        || page * pageSize < totalCount
    ),
  );
  const getFilters = (state, sliceId) => (
    get(state, [stateSliceName, itemSetNamePlural, sliceId, 'filters']) || {}
  );
  const getMultipleRequests = (state, sliceId) => (
    get(state, [stateSliceName, itemSetNamePlural, sliceId, 'multipleRequests']) || {}
  );
  const getSliceIds = state => Object.keys(get(state, [stateSliceName, itemSetNamePlural]));
  const getItems = createPerSliceIdSelector(
    (state, sliceId) => (
      get(state, [stateSliceName, itemSetNamePlural, sliceId, itemTypePlural])
        || range(getPageSize(state, sliceId))
    ),
    state => get(state, [stateSliceName, itemTypePlural]),
    (itemIds, allItems) => itemIds.map(id => (get(allItems, [id]) || {})),
  );
  const isBusy = (state, sliceId) => !!get(state, [stateSliceName, itemSetNamePlural, sliceId, 'busy']);
  const getError = (state, sliceId) => get(state, [stateSliceName, itemSetNamePlural, sliceId, 'error']);
  const isReadyOrError = (state, sliceId) => !isBusy(state, sliceId)
    && !!(
      get(state, [stateSliceName, itemSetNamePlural, sliceId, itemTypePlural, 'length'])
      || getError(state, sliceId)
    );

  return {
    getMultipleRequests,
    getPageSize,
    getTotalCount,
    getPage,
    hasMorePages,
    getFilters,
    getSliceIds,
    getItems,
    isBusy,
    getError,
    isReadyOrError,
  };
};
